import React from 'react';
import { Loading } from '@byte-design/ui';
import { observer } from 'mobx-react';
import Styles from './index.module.scss';
import { globalInfoStore } from '@/models/global';

const GLoading: React.FC = () => (
  <div
    className={Styles.globalLoding}
    style={{
      display: globalInfoStore.loading ? 'block' : 'none',
    }}
  >
    <Loading.BlockLoading show iconStyle={{ color: '#338AFF' }} />
  </div>
);

export default React.memo(observer(GLoading));
